// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_badge__EUOtU {
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: center;
  gap: 6px;
  background: rgb(247, 246, 255);
  max-width: 350px;
  margin: 12px auto 0 auto;
  padding: 12px;
  border-radius: 16px;
  align-items: center;
  gap: 12px;
}
.style_badge__part__gSThJ {
  flex: 1 1;
  display: flex;
  justify-content: center;
}
.style_badge__icon__iRzdO {
  width: 40px;
  height: 40px;
  border: 2px solid rgb(255, 199, 1);
  position: relative;
  border-radius: 100px;
  background: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_badge__icon__iRzdO p {
  color: rgb(213, 212, 220);
}
.style_badge__notification__ShEDD {
  position: absolute;
  top: -4px;
  right: -3px;
}
.style_badge__content__15VMU {
  display: flex;
  flex: 5 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 6px;
}
.style_badge__content__head__TcnSa {
  display: flex;
  justify-content: space-between;
}
.style_badge__content__head__title__fcpLX {
  color: rgb(27, 27, 27);
  font-weight: 600;
  font-size: 1.8rem;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  font-family: "Montserrat", sans-serif;
}
.style_badge__content__head__part__2xle1 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.style_badge__content__head__subtitle__NkR8f {
  color: rgb(117, 83, 240);
  font-weight: 700;
  font-size: 1.2rem;
}
.style_badge__flag__Qeg2u {
  display: flex;
  align-items: center;
  outline: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  width: 33px;
  height: 40px;
}
.style_badge__flag__image__ANA4i {
  width: 100%;
  height: 100%;
}
.style_badge__flag__divider__2bwfa {
  width: 2px;
  height: 20px;
  background: rgb(213, 212, 220);
}

.style_toggle__BWawC {
  width: 35px;
  font-size: 18px;
  display: flex;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.style_toggle__BWawC:focus, .style_toggle__BWawC:active {
  outline: none;
  background-color: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/features/tower/user-badge/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,8BCJiB;EDKjB,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AADF;AAGE;EACE,SAAA;EACA,aAAA;EACA,uBAAA;AADJ;AAIE;EACE,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,8BCvBI;EDwBJ,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACE,yBC5BO;AD0Bb;AAME;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AAJJ;AAOE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,8BAAA;EACA,QAAA;AALJ;AAOI;EACE,aAAA;EACA,8BAAA;AALN;AAOM;EACE,sBCtDM;EDuDN,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,qCAAA;AALR;AAQM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AANR;AASM;EACE,wBC1ED;ED2EC,gBAAA;EACA,iBAAA;AAPR;AAYE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;AAVJ;AAYI;EACE,WAAA;EACA,YAAA;AAVN;AAaI;EACE,UAAA;EACA,YAAA;EACA,8BC5FO;ADiFb;;AAgBA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,wCAAA;EACA,qBAAA;EACA,wBAAA;AAbF;AAeE;EAEE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,wBAAA;EACA,qBAAA;AAdJ","sourcesContent":["@import '../../../../public/assets/colors';\n\n.badge {\n  padding-left: 20px;\n  padding-right: 20px;\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  background: $light-background;\n  max-width: 350px;\n  margin: 12px auto 0 auto;\n  padding: 12px;\n  border-radius: 16px;\n  align-items: center;\n  gap: 12px;\n\n  &__part {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n  }\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    border: 2px solid $yellow;\n    position: relative;\n    border-radius: 100px;\n    background: $white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    p {\n      color: $light-grey;\n    }\n  }\n\n  &__notification {\n    position: absolute;\n    top: -4px;\n    right: -3px;\n  }\n\n  &__content {\n    display: flex;\n    flex: 5;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 6px;\n\n    &__head {\n      display: flex;\n      justify-content: space-between;\n\n      &__title {\n        color: $black-extra;\n        font-weight: 600;\n        font-size: 1.8rem;\n        max-width: 120px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        flex: 1;\n        font-family: 'Montserrat', sans-serif;\n      }\n\n      &__part {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n      }\n\n      &__subtitle {\n        color: $main;\n        font-weight: 700;\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  &__flag {\n    display: flex;\n    align-items: center;\n    outline: none;\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n    width: 33px;\n    height: 40px;\n\n    &__image {\n      width: 100%;\n      height: 100%;\n    }\n\n    &__divider {\n      width: 2px;\n      height: 20px;\n      background: $light-grey;\n    }\n  }\n}\n\n.toggle {\n  width: 35px;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  -webkit-tap-highlight-color: transparent; // For Safari and other WebKit-based browsers\n  -moz-appearance: none; // For Firefox\n  -webkit-appearance: none; // For Safari and Chrome\n\n  &:focus,\n  &:active {\n    outline: none;\n    background-color: transparent; // Ensure no background is applied\n    box-shadow: none; // Remove any box-shadow\n    -webkit-box-shadow: none; // Ensure no WebKit box-shadow\n    -moz-box-shadow: none; // Ensure no Mozilla box-shadow\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `style_badge__EUOtU`,
	"badge__part": `style_badge__part__gSThJ`,
	"badge__icon": `style_badge__icon__iRzdO`,
	"badge__notification": `style_badge__notification__ShEDD`,
	"badge__content": `style_badge__content__15VMU`,
	"badge__content__head": `style_badge__content__head__TcnSa`,
	"badge__content__head__title": `style_badge__content__head__title__fcpLX`,
	"badge__content__head__part": `style_badge__content__head__part__2xle1`,
	"badge__content__head__subtitle": `style_badge__content__head__subtitle__NkR8f`,
	"badge__flag": `style_badge__flag__Qeg2u`,
	"badge__flag__image": `style_badge__flag__image__ANA4i`,
	"badge__flag__divider": `style_badge__flag__divider__2bwfa`,
	"toggle": `style_toggle__BWawC`
};
export default ___CSS_LOADER_EXPORT___;
